import * as React from 'react'
import { ThemeProvider } from 'components/theme-provider'
import { Toaster } from 'components/ui/sonner'

export default function RootLayout({ children }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      {children}
      <Toaster richColors position="top-right" />
    </ThemeProvider>
  )
}